import { render, staticRenderFns } from "./ReglamentoT.vue?vue&type=template&id=5156fa96&scoped=true"
import script from "./ReglamentoT.vue?vue&type=script&lang=js"
export * from "./ReglamentoT.vue?vue&type=script&lang=js"
import style0 from "./ReglamentoT.vue?vue&type=style&index=0&id=5156fa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156fa96",
  null
  
)

export default component.exports